<template>
    <ValidationProvider :name="label" :rules="rules" v-slot="{ errors, required }" :vid="computedVid" slim>
        <div class="migrol-form__input-wrapper" :class="{ 'migrol-form__input-wrapper--error' : errors.length > 0 }" :style="computedStyle">
            <label :for="$id('input')" class="migrol-form__input-label" v-if="label">
                {{label}}{{(required ? '*' : '')}}
                <InfoIcon v-if="infoIconImageUrl" extraCssClass="migrol-form__info-button--for-label">
                    <img :src="infoIconImageUrl" />
                </InfoIcon>
            </label>
            <VueSelect :placeholder="label" v-model="innerValue" :options="options" label="text" :reduce="option => option.id" :clearable="clearable" :searchable="searchable" :selectOnTab="selectOnTab" transition="" />
            <div class="migrol-form__error-message">{{errors[0]}}</div>
        </div>
    </ValidationProvider>
</template>

<script>
    import { ValidationProvider } from 'VeeValidate';
    import InfoIcon from './InfoIcon';

    export default {
        inheritAttrs: false,
        model: {
            event: 'change'
        },
        props: {
            label: {
                type: String
            },
            flex: {
                type: String,
                default: '1',
                required: false
            },
            value: {
                default: null
            },
            rules: {
                type: [Object, String],
                default: null,
                required: false
            },
            vid: {
                type: String,
                default: ''
            },
            options: {
                type: Array,
                required: true
            },
            clearable: {
                type: Boolean,
                default: false
            },
            searchable: {
                type: Boolean,
                default: false
            },
            selectOnTab: {
                type: Boolean,
                default: true
            },
            infoIconImageUrl: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                innerValue: null
            }
        },
        computed: {
            computedStyle() {
                return this.flex != '1' ? { flex: this.flex } : null;
            },
            computedVid() {
                if (this.vid !== '')
                    return this.vid;
                else
                    return this.$id('vid');
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(newValue) {
                    if (this.innerValue != newValue) {
                        this.innerValue = newValue;
                    }
                }
            },
            innerValue: {
                handler(newValue, oldValue) {
                    // update value
                    if (newValue != oldValue) {
                        this.$emit('change', newValue);
                    }
                }
            },
        },
        components: {
            ValidationProvider,
            InfoIcon
        }
    };
</script>